import React from "react"
import {ManagedSolutionsCustomer} from "../../resources/managedSolutions"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import Icon from "../Icon/Icon"
import classNames from "classnames"
import {kebabCase, startCase} from "lodash"
import moment from "moment"
import {Meta} from "../../resources/common"
import {useNavigate} from "react-router-dom"

interface ManagedSolutionsCustomersTableProps {
	customers: Array<ManagedSolutionsCustomer>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	fullHeight?: boolean
	meta?: Meta
	sortBy?: string
	sortFunction?: () => void
}

export default function ManagedSolutionsCustomersTable({
	customers,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	fullHeight,
	meta,
	sortBy,
	sortFunction,
}: ManagedSolutionsCustomersTableProps) {
	const noContent = customers.length === 0
	const navigate = useNavigate()

	const getTypeIcon = (customerType: string | undefined): JSX.Element | null => {
		if (!customerType) return null
		switch (customerType.toLowerCase()) {
			case "business":
			case "businessfbo":
			case "businesswallet":
				return <Icon icon={"toolbox"} />
			case "individual":
			case "individualwallet":
				return <Icon icon={"user-geometric-action---users"} />
			default:
				return null
		}
	}

	return (
		<div className={"managed-solutions-customers-table"}>
			<DataTable isEmpty={noContent} fullHeight={fullHeight} noContentText="No customers yet">
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						<DataTableCell>ID</DataTableCell>
						<DataTableCell>User IDs</DataTableCell>
						<DataTableCell>Type</DataTableCell>
						<DataTableCell>Status</DataTableCell>
						<DataTableCell clickable onClick={() => sortFunction?.()} sortable sortApplied={sortBy === "createdAt"}>
							Created At
						</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{customers.map((customer) => {
						const customerType = customer.attributes.customerType
						const status = customer.attributes.status
						const createdAt = customer.attributes.createdAt
						const typeIcon = customerType ? getTypeIcon(customerType) : null

						return (
							<DataTableRow
								key={customer.id}
								onClick={(e) => {
									e.preventDefault()
									navigate(`/managed-solutions/customers/${customer.id}`)
								}}
							>
								<DataTableCell className="data-table-id-cell">{customer.id}</DataTableCell>
								<DataTableCell>
									{customer.attributes.userIds.map((userId, index) => (
										<div key={index}>{userId}</div>
									))}
								</DataTableCell>
								<DataTableCell>
									<span className="icon">{typeIcon}</span>
								</DataTableCell>
								<DataTableCell>
									{status ? (
										<div className={classNames("customers-status", kebabCase(status))}>{startCase(status)}</div>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>{createdAt ? moment(createdAt).format("L LT") : "-"}</DataTableCell>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
